import posthog from "posthog-js";

import { dispatchAgoraEvent } from "@/lib/utils/dispatch-agora-event";

export function handleBoundaryError(error: unknown) {
  if (!(error instanceof Error)) return;

  if (error.name === "ConnectionDropError") return;

  posthog.captureException(error);

  dispatchAgoraEvent({
    eventAction: "error-boundary.unknown",
    eventDetails: {
      errorMessage: error.message,
      errorName: error.name,
      errorStack: error.stack?.split("\n").slice(0, 5).join("\n"),
    },
    eventKey: "main-error-fallback",
    eventLocation: "global",
    eventType: "product.error.captured",
  });
}
